export const EMAIL_TYPE = {
  GMAIL: 'GMAIL',
  OUTLOOK: 'OUTLOOK',
  BLOOBIRDS: 'BLOOBIRDS',
};

export const EMAIL_MODE = Object.freeze({
  REPLY: 'REPLY',
  SEND: 'SEND',
});
